var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { StepType } from "@types";
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateSource, validateStep, validateStepNameAndId } from "@utils";
import { FormSection } from "@components/FormSection/FormSection";
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput";
import { hasValue, Input } from "uxp/components";
import Icon from '@images/limit.svg';
export function renderStep(context, query, onChange, selectedStepId) {
    var _a;
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId);
    const _step = Object.assign({}, step);
    const $L = (key) => context.uxpContext.$L(key);
    const [errors, setErrors] = useState({});
    const [currentValue, setCurrentValue] = useState(((_a = _step === null || _step === void 0 ? void 0 : _step.rows) === null || _a === void 0 ? void 0 : _a.toString()) || '');
    useEffect(() => {
        const { isValid, errors } = validateStep(query, step);
        const resolved = Object.fromEntries(Object.entries(errors || {}).map(([k, v]) => [k, v && v.startsWith('lqe.') ? $L(v) : v]));
        setErrors(resolved);
    }, [step]);
    const source = findSourceById(query, _step === null || _step === void 0 ? void 0 : _step.source);
    function onValueChange(field, value, source) {
        return __awaiter(this, void 0, void 0, function* () {
            const _query = yield handleStepFieldValueChanges(context, query, selectedStepId, field, value, source);
            onChange(_query);
        });
    }
    function submitValue() {
        var x = Number(currentValue) || 0;
        onValueChange('rows', x);
        setCurrentValue(x.toString());
    }
    return React.createElement(React.Fragment, null,
        React.createElement(FormSection, { label: $L('lqe.step.limit.source'), error: errors === null || errors === void 0 ? void 0 : errors.source },
            React.createElement(SourceSelectorInput, { source: source, onChange: newSource => {
                    onValueChange('source', newSource, true);
                }, availableSources: [...previousSteps, ...selectedSources], query: query })),
        React.createElement(FormSection, { label: $L('lqe.step.limit.max-records'), error: errors === null || errors === void 0 ? void 0 : errors.rows },
            React.createElement(Input, { value: currentValue, onChange: v => {
                    setCurrentValue(v);
                }, onBlur: () => {
                    submitValue();
                }, onKeyDown: e => {
                    if (e.key == 'Enter') {
                        submitValue();
                    }
                } })));
}
function validate(query, step) {
    const errors = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source');
    if (!source.isValid)
        errors.source = source.error;
    if (!hasValue(step === null || step === void 0 ? void 0 : step.rows))
        errors.rows = 'lqe.step.limit.error-invalid-rows';
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}
registerStep({
    type: StepType.Limit,
    name: "lqe.step.limit.name",
    description: "lqe.step.limit.description",
    icon: Icon,
    iconStyles: {
        backgroundSize: '55%'
    },
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return Object.assign(Object.assign({}, basicProps), { source: previousSource, rows: 10 });
    }
});
